import { SETTINGS } from 'store/actions/types'
import { setMicrophonePermissionDenied } from 'store/actions/global'
import { MicrophoneMediaStream } from 'common/Globals'

export const setUserMode = (payload) => ({
    type: SETTINGS.SET_USER_MODE,
    payload
})

export const getDevices = () => {
    return async (dispatch) => {
        const supportedConstraints = navigator.mediaDevices.getSupportedConstraints()
        const audioConstraints = supportedConstraints?.echoCancellation ? { echoCancellation: true } : true

        navigator.mediaDevices
            .getUserMedia({ audio: audioConstraints, video: false })
            .then((mediaStream) => {
                if (navigator?.mediaDevices?.enumerateDevices) {
                    MicrophoneMediaStream.current = mediaStream

                    navigator.mediaDevices
                        .enumerateDevices()
                        .then((devices) => {
                            const devicesObj = {
                                audioinput: {},
                                audiooutput: {},
                                videoinput: {}
                            }
                            // TODO: it must be checked at all browsers
                            devices.forEach((device) => {
                                if (devicesObj[device.kind]) {
                                    devicesObj[device.kind][device.groupId] = {
                                        id: device.deviceId,
                                        groupId: device.groupId,
                                        name: device.label,
                                        isSelected: false
                                    }
                                }
                            })
                            dispatch(getDevicesSuccess({ data: devicesObj }))
                            dispatch(setMicrophonePermissionDenied(!Object.keys(devicesObj.audioinput).length))
                        })
                        .catch((e) => {
                            dispatch(getDevicesFail(e))
                            dispatch(setMicrophonePermissionDenied(true))
                        })
                } else {
                    // TODO: check case when enumerateDevices don't support
                    dispatch(setMicrophonePermissionDenied(true))
                }
            })
            .catch((e) => {
                dispatch(setMicrophonePermissionDenied(true))
            })
    }
}

export const getDevicesSuccess = (payload) => ({
    type: SETTINGS.GET_DEVICES_SUCCESS,
    payload
})

export const getDevicesFail = (payload) => ({
    type: SETTINGS.GET_DEVICES_FAIL,
    payload
})

export const onVolumeChange = (payload) => ({
    type: SETTINGS.CHANGE_VOLUME,
    payload
})

export const onCallPreferencesChange = (payload) => ({
    type: SETTINGS.CHANGE_CALL_PREFERENCES,
    payload
})

export const onDeviceConfigChange = (id, configName) => (dispatch) =>
    dispatch({
        type: SETTINGS.CHANGE_DEVICE_CONFIG,
        payload: { id, configName }
    })

export const changeAutoReject = (payload) => ({
    type: SETTINGS.CHANGE_AUTO_REJECT,
    payload
})

export const changeAutoPickup = (payload) => ({
    type: SETTINGS.CHANGE_AUTO_PICKUP,
    payload
})

export const setCodecPreferences = (payload) => ({
    type: SETTINGS.SET_CODEC_PREFERENCES,
    payload
})

export const setIntegrationNumberSearch = (payload) => ({
    type: SETTINGS.SET_INTEGRATION_NUMBER_SEARCH,
    payload
})

export const setSearchOnlyKavkomCrm = (payload) => ({
    type: SETTINGS.SET_SEARCH_KAVKOMCRM_ONLY,
    payload
})
